export default "__VITE_ASSET__BwLO_Ifh__"